<div class="container-fluid my-profile">
  <div class="row breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row" [ngClass]="isMobile && !page ? 'd-none' : ''">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb [data]="breadcrumbData"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row dealer-review-row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row g-0">
          <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3">

            <div class="rewards-card card"  (click)="menuClick('rewardsPage')" [ngClass]="page == 'rewardsPage' ? ' active' : ''" id="pills-rewards-tab" data-bs-toggle="pill"
              data-bs-target="#pills-rewards" type="button" role="tab" aria-controls="pills-rewards"
              aria-selected="false" [routerLink]="'/account/rewardsPage'">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center " style="margin: 0px 20px;">
                    <div class="title">Redeem Rewards</div>
                    <span class="chevron">›</span>
                  </div>
                  <div class="wallet-balance">
                    Wallet Balance
                    <div class="d-flex align-items-center mt-1">
                      <img [src]="environment1 + 'assets/images/Layer_2.webp'" class="coin-icon me-2" alt="Coin-Icon" loading="lazy">
                      <span class="amount" *ngIf="userBal">{{userBalance?.current_balance}}</span>
                      <div >
                        <span class="amount" *ngIf="!userBal">{{ userBalance ? userBalance : 0}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <ul class="list-group nav nav-pills mb-4" [ngClass]="isMobile && page ? 'd-none' : ''">
              <li class="list-group-item">
                <button class="nav-link  w-100 d-flex align-items-center" (click)="menuClick('profilePage')"
                  [ngClass]="page == 'profilePage' ? ' active' : ''" id="pills-profile-tab" data-bs-toggle="pill"
                  data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                  aria-selected="false" [routerLink]="'/account/profilePage'">
                  <div class="d-flex align-items-baseline">
                    <div class="icon">
                      <img [src]='environment1 + "assets/images/user-icon.png"' class="user-icon" alt="user ICON"
                        loading="lazy">
                    </div>
                    <div class="content">
                      <div class="title text-start">My Profile</div>
                      <p class="mb-0">Edit & manage your profile</p>
                    </div>
                  </div>
                </button>
              </li>

              <li class="list-group-item">
                <button (click)="menuClick('Bookings')" class="nav-link w-100 d-flex align-items-center"
                  [ngClass]="page == 'Bookings' || page =='Builds' ? ' active' : ''" id="pills-booking-tab" data-bs-toggle="tab"
                  data-bs-target="#pills-booking" type="button" role="tab" aria-controls="pills-booking"
                  aria-selected="false" [routerLink]="'/account/booking'">
                  <div class="d-flex align-items-baseline">
                    <div class="icon">
                      <img [src]='environment1 + "assets/images/booking-icon.png"' class="booking-icon"
                        alt="booking ICON" loading="lazy">
                    </div>
                    <div class="content">
                      <div class="title text-start">My Finance & Bookings</div>
                      <p class="mb-0">View & manage booking status</p>
                    </div>
                  </div>
                </button>
              </li>
              <li class="list-group-item">
                <button class="nav-link w-100 d-flex align-items-center" (click)="menuClick('testDrive')"
                  [ngClass]="page == 'testDrive' ? ' active' : ''" id="pills-testDrive-tab" data-bs-toggle="tab"
                  data-bs-target="#pills-testDrive" type="button" role="tab" aria-controls="pills-testDrive"
                  aria-selected="false" [routerLink]="'/account/testDrive'">
                  <div class="d-flex align-items-baseline">
                    <div class="icon">
                      <img [src]='environment1 + "assets/images/test-drive-icon.png"' class="testDrive-icon"
                        alt="Test Drive ICON" loading="lazy">
                    </div>
                    <div class="content">
                      <div class="title text-start">My Test Drive</div>
                      <p class="mb-0">View & manage your test drive</p>
                    </div>
                  </div>
                </button>
              </li>
              <li class="list-group-item">
                <button class="nav-link w-100 d-flex align-items-center" [ngClass]="page == 'wishList' ? ' active' : ''"
                  (click)="menuClick('wishList')" [routerLink]="'/account/wishList'" id="pills-wishlist-tab"
                  data-bs-toggle="tab" data-bs-target="#pills-wishlist" type="button" role="tab"
                  aria-controls="pills-wishlist" aria-selected="false">
                  <div class="d-flex align-items-baseline">
                    <div class="icon">
                      <img [src]='environment1 + "assets/images/like-icon.png"' class="wishlist-icon"
                        alt="whishlist ICON" loading="lazy">
                    </div>
                    <div class="content">
                      <div class="title text-start">My Wishlist</div>
                      <p class="mb-0">Manage your shortlisted vehicles</p>
                    </div>
                  </div>
                </button>
              </li>
              <li class="list-group-item">
                <button class="nav-link w-100 d-flex align-items-center" [ngClass]="page == 'kyc' ? ' active' : ''"
                  (click)="menuClick('kyc')" id="pills-kycdetail-tab" data-bs-toggle="tab"
                  data-bs-target="#pills-kycdetail" type="button" role="tab" aria-controls="pills-kycdetail"
                  aria-selected="false" [routerLink]="'/account/kyc'">
                  <div class="d-flex align-items-baseline">
                    <div class="icon">
                      <img [src]='environment1 + "assets/images/kyc-icon.png"' class="kyc-icon" alt="kyc ICON"
                        loading="lazy">
                    </div>
                    <div class="content">
                      <div class="title text-start">KYC Details</div>
                      <p class="mb-0">View your KYC details and status </p>
                    </div>
                  </div>
                </button>
              </li>
              <li class="list-group-item">
                <button class="nav-link w-100 d-flex align-items-center" [ngClass]="page == 'vas-dashboard' ? ' active' : ''"
                  (click)="menuClick('vas')" id="pills-amcdetail-tab" data-bs-toggle="tab"
                  data-bs-target="#pills-amccdetail" type="button" role="tab" aria-controls="pills-amcdetail"
                  aria-selected="false" [routerLink]="'/account/vas-dashboard'">
                  <div class="d-flex align-items-baseline">
                    <div class="icon">
                      <img [src]='environment1 + "assets/images/advancesearch/AMC.png"' class="amc-icon" alt="vas ICON"
                        loading="lazy">
                    </div>
                    <div class="content">
                      <div class="title text-start">VAS Digital Dashboard</div>
                      <p class="mb-0">View your VAS Digital Dashboard </p>
                    </div>
                  </div>
                </button>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 col-xxl-9">
            <div class="tab-content ps-lg-3" id="pills-tabContent">
              <app-user-profile *ngIf="page == 'profilePage'" (goBack)="goBack()"></app-user-profile>
              <div class="tab-pane fade" [ngClass]="page == 'TataOk' || page == 'Bookings' || page == 'Builds' || page=='FNIJOURNEY' ? 'show active' : ''" id="pills-booking"
                role="tabpanel" aria-labelledby="pills-booking-tab">
                <div class="d-md-flex align-items-center justify-content-between d-block">
                  <div class="d-flex">
                    <h1 class="page-sub-title cv-text-dark mb-3" *ngIf="page=='TataOk'">
                      <a (click)="mobileBack()" class="">
                        <img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2"
                          loading="lazy" />
                      </a>Used Vehicles
                    </h1>
                    <h1 class="page-sub-title cv-text-dark mb-3" *ngIf="page=='Bookings'">
                      <a (click)="mobileBack()" class="">
                        <img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2" loading="lazy" />
                      </a>My Finance & Bookings
                    </h1>
                    <h1 class="page-sub-title cv-text-dark mb-3" *ngIf="page=='Builds'">
                      <a (click)="mobileBack()" class="">
                        <img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2" loading="lazy" />
                      </a>My Configurator
                    </h1>
                    <h1 class="page-sub-title cv-text-dark mb-3" *ngIf="page=='GensetBookings'">
                      <a (click)="mobileBack()" class="">
                        <img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2" loading="lazy" />
                      </a>Genset Booking
                    </h1>
                    <h1 class="page-sub-title cv-text-dark mb-3" *ngIf="page=='FNIJOURNEY'">
                      <a (click)="mobileBack()" class="">
                        <img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2" loading="lazy" />
                      </a>F&I JOURNEY
                    </h1>
                  </div>
                  <ul class="nav nav-pills nav-fill mb-3" id="pills-tab-test-drive" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" [ngClass]="{'active' : page == 'Bookings'}" id="pills-Bookings-tab"
                        data-bs-toggle="pill" data-bs-target="#pills-Bookings" type="button" role="tab" aria-controls="pills-Bookings"
                        aria-selected="true" (click)="menuClick('Bookings')">Fleetverse Booking</button>
                    </li>
                    <li *ngIf="dealerCode" class="nav-item" role="presentation">
                      <button class="nav-link" [ngClass]="{'active' : page == 'FNIJOURNEY'}" id="pills-configurator"
                        data-bs-toggle="pill" data-bs-target="#pills-Builds" type="button" role="tab"
                        aria-controls="pills-configurator-tab" aria-selected="false" (click)="menuClick('FNIJOURNEY')">Non Fleetverse Booking</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" [ngClass]="{'active' : page == 'Builds'}" id="pills-configurator"
                        data-bs-toggle="pill" data-bs-target="#pills-Builds" type="button" role="tab" aria-controls="pills-configurator-tab"
                        aria-selected="false" (click)="menuClick('Builds')">Builds</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button 
                        class="nav-link" 
                        [ngClass]="{'active': page == 'TataOk'}" 
                        id="pills-TataOk-tab"
                        type="button" 
                        role="tab"
                        aria-controls="pills-TataOk"
                        aria-selected="true" data-bs-toggle="pill"
                        data-bs-target="#pills-TataOk"
                        (click)="menuClick('TataOk')">
                        Used Vehicles Booking
                      </button>
                    </li>
                  </ul>
                </div>


              <app-booking-list  *ngIf="page == 'Bookings'" (goBack)="goBack()"></app-booking-list>
              </div>
              <app-test-drive-list (goBack)="goBack()" *ngIf="page == 'testDrive'"></app-test-drive-list>
              <app-wishlist-list (goBack)="goBack()" *ngIf="page == 'wishList'"></app-wishlist-list>
              <app-configurator-list (goBack)="goBack()" *ngIf="page == 'Builds'"></app-configurator-list>
              <app-kyc-profile (goBack)="goBack()" *ngIf="page == 'kyc'"></app-kyc-profile>
              <app-vas-dashboard (goBack)="goBack()" *ngIf="page == 'vas-dashboard'"></app-vas-dashboard>
              <app-fni-journey (goBack)="goBack()" *ngIf="page == 'FNIJOURNEY'"></app-fni-journey>
              <app-redeem-rewards (goBack)="goBack()" *ngIf="page == 'rewardsPage'"></app-redeem-rewards>
              <app-reward-center (goBack)="goBack()" *ngIf="page == 'reward-center'" ></app-reward-center>
              <app-reward-gift-card (goBack)="goBack()" *ngIf="page == 'reward-gift-card'"  ></app-reward-gift-card>
              <app-reward-statement (goBack)="goBack()" *ngIf="page == 'reward-statement'"  ></app-reward-statement>
              <app-tataok-fni-journey (goBack)="goBack()" *ngIf="page == 'TataOk'"></app-tataok-fni-journey>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--logout modal-->
<div class="modal fade logout-modal" id="logout-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="logout-modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-body">
        <div class="d-flex mb-3">
       <img [src]='environment1 + "assets/images/new-images/invalid.svg"' alt="invalid" loading="lazy">
          <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <h4>Logout</h4>
        <div class="mb-5">
          Are you sure you want to logout?
        </div>
        <div class="row gx-3">
          <div class="col-6">
            <button class="btn social-login btn-outline-primary btn-grad-outline-primary btn-brand w-100"
              (click)=clickToLogout()>Yes</button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-danger btn-lg  w-100" data-bs-dismiss="modal"
              aria-label="Close">No</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
